
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 23.2C5.814 23.2.8 18.186.8 12 .8 5.814 5.814.8 12 .8 18.186.8 23.2 5.814 23.2 12c0 6.186-5.014 11.2-11.2 11.2z","fill":"#00003C"}}),_c('path',{attrs:{"d":"M9.6 6H8.4a1.2 1.2 0 00-1.2 1.2v9.6A1.2 1.2 0 008.4 18h1.2a1.2 1.2 0 001.2-1.2V7.2A1.2 1.2 0 009.6 6zm.4 10.8a.4.4 0 01-.4.4H8.4a.4.4 0 01-.4-.4V7.2c0-.22.18-.4.4-.4h1.2c.22 0 .4.18.4.4v9.6zM15.6 6h-1.2a1.2 1.2 0 00-1.2 1.2v9.6a1.2 1.2 0 001.2 1.2h1.2a1.2 1.2 0 001.2-1.2V7.2A1.2 1.2 0 0015.6 6zm.4 10.8a.4.4 0 01-.4.4h-1.2a.4.4 0 01-.4-.4V7.2c0-.22.18-.4.4-.4h1.2c.22 0 .4.18.4.4v9.6z","fill":"#00003C"}})])
          )
        }
      }
    